import MainLayout from 'layouts/MainLayout';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { CommonConstant, RegexConstant } from 'constants/code.constant';
import useAccount from 'hooks/useAccount';
import React, { useEffect, useState } from 'react';
import AccountRepository from 'repositories/AccountRepository';
import CommonUtil from 'utils/common.util';
import { ErrorCodeConstant } from 'constants/errorCode.constant';

const defaultValues = {
  password: '',
  passwordConfirm: '',
  company: '', // 소속명
  phoneNumber: '', // 담당자 연락처
};

let schemeObject = {
  company: yup.string().trim().required('소속명을 입력해 주세요'),
  phoneNumber: yup
    .string()
    .trim()
    .required('전화번호를 입력해 주세요.')
    .matches(RegexConstant.phone, `전화번호 형식이 올바르지 않습니다('-'포함)`),
};

const schemeObjectPw = {
  password: yup.string().required('새 비밀번호를 입력해 주세요'),
  passwordConfirm: yup
    .string()
    .required('새 비밀번호를 확인해 주세요')
    .oneOf([yup.ref('password'), null], '새 비밀번호가 일치하지 않습니다'),
};

const MyPage = () => {
  const [isChangePassword, setIsChangePassword] = useState(false);

  if (isChangePassword) {
    schemeObject = { ...schemeObject, ...schemeObjectPw };
  }

  const schema = yup.object().shape(schemeObject);

  const {
    control,
    handleSubmit,
    getValues,
    reset,
    formState: { errors },
  } = useForm({ defaultValues, mode: 'onBlur', resolver: yupResolver(schema) });

  const { useGetMyAccount } = useAccount();
  const { accountInfo } = useGetMyAccount();

  const saveMyAccount = (formData) => {
    AccountRepository.saveMyAccount(formData)
      .then((res) => {
        if (res.result === CommonConstant.OK) {
          alert('저장하였습니다');
          window.location.reload();
        }

        if (res.result === CommonConstant.ERROR) {
          // 기업 중복
          if (res.errorCode === ErrorCodeConstant.ERROR_CODE.DUPLICATE_COMPANY) {
            alert('기업명은 중복될 수 없습니다');
          }
        }
      })
      .catch(CommonUtil.repoErrFunc);
  };

  useEffect(() => {
    if (accountInfo) {
      reset({ ...getValues(), ...accountInfo });
    }
  }, [accountInfo]);

  return (
    <MainLayout>
      <form noValidate autoComplete="off" onSubmit={handleSubmit(saveMyAccount)}>
        <div className="page-header">계정 정보</div>
        <div className="page-card">
          <div className="table-search-wrap detail-form-wrap">
            <div>
              <label>이메일(아이디)</label>
              <input type="text" value={accountInfo?.email ?? ''} disabled />
            </div>
            <div>
              <label>비밀번호 재설정</label>
              <input
                type="checkbox"
                value={isChangePassword}
                onChange={(e) => {
                  setIsChangePassword(e.target.checked);
                }}
              />
            </div>
            <div />
            {isChangePassword && (
              <>
                <Controller
                  name={'password'}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { ref, onBlur, value, onChange } }) => (
                    <div>
                      <label>새 비밀번호</label>
                      <input
                        ref={ref}
                        type="password"
                        autoComplete="off"
                        maxLength={100}
                        onBlur={onBlur}
                        value={value}
                        onChange={onChange}
                        placeholder="새 비밀번호"
                      />
                      {errors.password && <p className="error">{errors.password.message}</p>}
                    </div>
                  )}
                />
                <div />
                <Controller
                  name={'passwordConfirm'}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { ref, onBlur, value, onChange } }) => (
                    <div>
                      <label>새 비밀번호 확인</label>
                      <input
                        ref={ref}
                        type="password"
                        maxLength={100}
                        onBlur={onBlur}
                        value={value}
                        onChange={onChange}
                        placeholder="새 비밀번호 확인"
                      />
                      {errors.passwordConfirm && <p className="error">{errors.passwordConfirm.message}</p>}
                    </div>
                  )}
                />
              </>
            )}
          </div>
        </div>
        <br />
        <div className="page-card">
          <div className="table-search-wrap detail-form-wrap">
            <Controller
              name={'company'}
              control={control}
              rules={{ required: true }}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>소속명</label>
                  <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="소속명"
                    maxLength={100}
                  />
                  {errors.company && <p className="error">{errors.company.message}</p>}
                </div>
              )}
            />
            <div />
            <Controller
              name={'name'}
              control={control}
              rules={{ required: true }}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>담당자 성명</label>
                  <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="담당자 성명"
                    maxLength={50}
                  />
                  {errors.name && <p className="error">{errors.name.message}</p>}
                </div>
              )}
            />
            <Controller
              name={'phoneNumber'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>담당자 연락처</label>
                  <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="'-' 포함"
                    maxLength={20}
                  />
                  {errors.phoneNumber && <p className="error">{errors.phoneNumber.message}</p>}
                </div>
              )}
            />
          </div>
        </div>
        <br />
        <div className="display-flex space-between">
          <div />
          <button className="btn add-btn" type="submit">
            저장
          </button>
        </div>
      </form>
    </MainLayout>
  );
};

export default MyPage;
